import { Paper, styled } from '@mui/material';

const RootContainer = styled('div')(() => ({
  width: '100%',
  flex: 1,
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
}));

const PaperStyled = styled(Paper)(() => ({
  width: '100%',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  minHeight: 0,
}));

export { RootContainer, PaperStyled };
